import React, { useEffect, useState, useRef } from 'react';
import { usePlayerContext } from '../Context';
import ControlMenu from '../ui/ControlMenu';
import ControlList from '../ui/ControlsList';
import { ControlsPosition, Events } from '../../types/player';

const SubMenu = () => {
  const { sdk } = usePlayerContext();
  const [open, setOpen] = useState<boolean>(false);
  const [openSubMenu, setOpenSubMenu] = useState<boolean>(false);
  const listeners = useRef<() => void>();

  useEffect(() => {
    return () => {
      if (listeners.current) {
        listeners.current();
      }
    };
  }, []);

  useEffect(() => {
    listeners.current = sdk.on(
      Events.TOGGLE_CONTROL_MENU,
      (control: string) => {
        if (control == 'sub-menu') {
          setOpen(!open);
          setOpenSubMenu(false);
        } else if (open) {
          setOpenSubMenu(!openSubMenu);
        }
      },
    );
    return () => {
      if (listeners.current) {
        listeners.current();
      }
    };
  }, [open, openSubMenu]);

  let controls = sdk.options().getControls().list(ControlsPosition.SUB_MENU);

  if (!controls || controls.length < 1) return null;

  const selector = (
    <div
      className={`
        ${sdk.getClassNamePrefix()}-player-control-menu-list 
        ${sdk.getClassNamePrefix()}-player-control-menu-list-sub-menu 
        ${openSubMenu ? sdk.getClassNamePrefix() + '-player-control-menu-list-sub-menu-open ' : ''}`}
    >
      <div
        className={`${sdk.getClassNamePrefix()}-player-control-menu-item ${sdk.getClassNamePrefix()}-player-control-menu-item-submenu`}
      >
        <ControlList controls={controls} />
      </div>
    </div>
  );
  return (
    <ControlMenu
      icon={'gear'}
      controlClassName={'sub-menu'}
      title={'Settings'}
      content={selector}
    />
  );
};

export default SubMenu;
